(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aya-bon-cart-feedback"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aya-bon-cart-feedback')) {
  customElements.define('aya-bon-cart-feedback', class extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('.shopify-section');
      if (!this.scope || this.observer) return;
      this.observer = new MutationObserver(() => this.schedule());
      this.observer.observe(this.scope, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class', 'disabled', 'value', 'aria-disabled']
      });
      this.update();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
    }

    schedule() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.update();
      });
    }

    progress(text) {
      const match = text.trim().match(/^Saldo de Estrellas:\s*(\d+)\.\s*Acumula\s*(\d+)\s*para conseguir\s*([^<>]+?)\s*de descuento\.$/u);
      if (!match) return null;
      const balance = Number(match[1]);
      const target = Number(match[2]);
      if (!Number.isSafeInteger(balance) || !Number.isSafeInteger(target) || target <= balance) return null;
      return this.dataset.progress
        .replace('__balance__', match[1])
        .replace('__remaining__', String(target - balance))
        .replace('__reward__', match[3]);
    }

    update() {
      for (const root of this.scope.querySelectorAll('.bon-cart-container')) {
        const select = root.querySelector('#bon-reward-select');
        const points = root.querySelector('#bon-cart-display-points');
        const group = select?.closest('.bon-cart-select-group');
        let message = root.querySelector('[data-aya-bon-message]');
        const pointText = points?.textContent?.trim() || '';
        const hasReward = select && Array.from(select.options).some(option =>
          option.value.trim() && option.text.trim() && !option.disabled &&
          !(option.parentElement.tagName === 'OPTGROUP' && option.parentElement.disabled)
        );
        const empty = Boolean(select && group && pointText && !hasReward);
        root.toggleAttribute('data-aya-bon-empty', empty);
        if (!empty) {
          root.removeAttribute('data-aya-bon-progress');
          if (message) message.hidden = true;
          continue;
        }
        const progress = this.progress(pointText);
        const text = progress || this.dataset.unavailable;
        root.toggleAttribute('data-aya-bon-progress', Boolean(progress));
        if (!message) {
          message = document.createElement('p');
          message.className = 'aya-bon-cart-feedback';
          message.dataset.ayaBonMessage = '';
          message.setAttribute('role', 'status');
          message.setAttribute('aria-live', 'polite');
          message.setAttribute('aria-atomic', 'true');
          points.after(message);
        }
        if (message.textContent !== text) message.textContent = text;
        if (message.hidden) message.hidden = false;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aya-product-confidence"] && !Shopify.designMode) return;
  try {
    (() => {
  const updateReviewVisibility = () => {
    document.querySelectorAll('.jdgm-prev-badge').forEach((badge) => {
      const rawCount = badge.getAttribute('data-number-of-reviews');

      if (rawCount === null) {
        return;
      }

      const wrapper = badge.closest('.shopify-block') || badge;
      wrapper.hidden = Number(rawCount) <= 0;
    });
  };

  document.addEventListener('DOMContentLoaded', updateReviewVisibility);
  document.addEventListener('shopify:section:load', updateReviewVisibility);

  const reviewObserver = new MutationObserver(updateReviewVisibility);
  reviewObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aya-soldout-whatsapp"] && !Shopify.designMode) return;
  try {
    (()=>{const norm=s=>(s||'').trim().toLowerCase();const setupSoldoutWhatsapp=(root=document)=>{root.querySelectorAll('[data-aya-soldout-whatsapp]').forEach(box=>{if(box.dataset.ayaReady==='true')return;box.dataset.ayaReady='true';const link=box.querySelector('[data-aya-whatsapp-link]');if(!link)return;link.addEventListener('click',()=>{link.removeAttribute('target');const isPt=box.dataset.ayaLanguage==='pt';const productInfo=box.closest('.product__info')||document;const title=productInfo.querySelector('.product-meta__title')?.textContent?.trim()||document.title;const selectors=[...productInfo.querySelectorAll('.product-form__option-selector')];const sizeSelector=selectors.find(selector=>{const name=norm(selector.querySelector('.product-form__option-name')?.textContent);return name.includes('talla')||name.includes('size')||name.includes('tamanho')});let soldoutSize='';if(sizeSelector){const checkedSoldout=sizeSelector.querySelector('.block-swatch.is-disabled input:checked + label');soldoutSize=checkedSoldout?.textContent?.trim()||''}let message;if(isPt){const sizeText=soldoutSize?` O tamanho selecionado é ${soldoutSize}.`:' O tamanho de que preciso aparece esgotado.';message=`Olá, estou interessada em "${title}".${sizeText} Podem tentar consegui-lo? ${window.location.href}`}else{const sizeText=soldoutSize?` La talla seleccionada es ${soldoutSize}.`:' La talla que necesito aparece agotada.';message=`Hola, estoy interesada en "${title}".${sizeText} ¿Podéis intentar conseguirla? ${window.location.href}`}link.href=`https://wa.me/34686140859?text=${encodeURIComponent(message)}`})})};document.addEventListener('DOMContentLoaded',()=>setupSoldoutWhatsapp());document.addEventListener('shopify:section:load',e=>setupSoldoutWhatsapp(e.target))})();
  } catch(e) { console.error(e); }
})();

})();
